// Shen.AI's WASM SDK runs its render loop inside a Web Worker that creates an
// `OffscreenCanvas` with a `webgl2` context. Older Safari builds (notably iOS
// 16.x on iPhone X — the last iOS that device receives) ship `OffscreenCanvas`
// but refuse to acquire `webgl2` on it, throwing
// `Browser incompatible: OffscreenCanvas cannot be created with 'webgl2' context.`
// at SDK init.
//
// Detect the capability up-front so we can hide the feature instead of letting
// the user start a measurement that's guaranteed to fail. Result is cached for
// the lifetime of the page — the test creates a canvas, so cheap is good.
let cached: boolean | null = null;

export function isShenaiCompatible(): boolean {
  if (cached !== null) {
    return cached;
  }
  if (typeof OffscreenCanvas === 'undefined') {
    cached = false;
    return cached;
  }
  try {
    const probe = new OffscreenCanvas(1, 1);
    const ctx = probe.getContext('webgl2');
    cached = ctx !== null;
  } catch {
    cached = false;
  }
  return cached;
}
